(function () {
    'use strict';

    angular
        .module('app.dashboard')
        .run(appRun);

    appRun.$inject = ['routerHelper', 'opsIncludeVersion'];
    /* @ngInject */
    function appRun(routerHelper, opsIncludeVersion) {
        routerHelper.configureStates(getStates(opsIncludeVersion));
    }

    function getStates(opsIncludeVersion) {
        return [
            {
                state: 'dashboard',
                config: {
                    url: '/',
                    templateUrl: 'app/dashboard/dashboard.html?v=' + opsIncludeVersion,
                    controller: 'DashboardController',
                    controllerAs: 'vm',
                    title: 'Dashboard',
                    settings: {
                        nav: 1,
                        content: '<i class="fa fa-dashboard"></i> <span class="leftNavText">Dashboard</span>',
                        authMode: 1,
                        requireOps: true,
                        mobileButton: true
                    },
                    resolve: {
                        authenticationRequired: ['userService', function (userService) {
                            userService.isAuthenticatedThrowError();
                        }]
                    }
                }
            }
        ];
    }
})();
